<template>
  <AppHeader />
  <q-page-container class="base-wrapper" style="padding: 0;">
    <router-view v-slot="{ Component }">
      <suspense timeout="0">
        <template #default>
          <component :is="Component" :key="$route.path"></component>
        </template>
        <template #fallback>
          <q-inner-loading :showing="true" label="Идет загрузка...">
          <AppLoader />
        </q-inner-loading>
        </template>
      </suspense>
    </router-view>
  </q-page-container>
  <q-inner-loading :showing="isLoading">
    <AppLoader />
  </q-inner-loading>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import AppHeader from '~components/AppHeader.vue';
import AppLoader from '~components/AppLoader.vue';

defineProps({
  isLoading: {
    type: Boolean as PropType<boolean>,
  },
});
</script>

<style>
.base-wrapper {
  position: fixed;
  z-index: 1000;
  top: 50px;
  width: 100%;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
</style>
